export default __webpack_public_path__ + "static/Bone@2x-53cd74b8b9b4012c5e460ba70d7542cf.png";